<!-- 予約/購入完了 -->
<template>
  <TemplateMfittBookingResult />
</template>

<script>
import TemplateMfittBookingResult from "@/views/Templates/MFITT/TemplateMfittBookingResult";

import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

export default {
  name: "MfittBookingResult",
  components: {
    TemplateMfittBookingResult,
  },
  setup() {},
};
</script>
